import { digObject } from '@domain-group/javascript-utils'

import { baseURL } from '@functions/api'

import { CampaignComparableModel } from '@models/types'

import callApi from './callApi'

const comparableCategoryKeys = [
  'agency_all',
  'agency_current',
  'agency_sold',
  'market_all',
  'market_current',
  'market_rental',
  'market_sold',
]

export type ComparableCategoryKey = typeof comparableCategoryKeys[number]

export const getComparableType = (comparableType: string) => {
  if (comparableType === 'agency_current' || comparableType === 'market_current'){
    return 'current'
  }

  if (comparableType === 'agency_all' || comparableType === 'market_all'){
    return 'all'
  }

  if (comparableType === 'market_rental'){
    return 'rental'
  }

  return 'sold'
}

type GetComparableUrlParams = {
  comparableType: ComparableCategoryKey,
  dataProviderPropertyId: number,
}

export const getComparableUrl = (params: GetComparableUrlParams) => {
  const { comparableType, dataProviderPropertyId } = params

  if (comparableType === 'agency_current' || comparableType === 'agency_sold' || comparableType === 'agency_all'){
    return `${baseURL}/campaign_comparables/campaign_search`
  }

  return `${baseURL}/data_providers/${dataProviderPropertyId}/comparables`
}

export function getSavedDataProviderIds(campaignComparables: CampaignComparableModel[]) {
  const savedIds: number[] = []

  Object.values(campaignComparables).forEach((comparable) => {
    const entityId = digObject(comparable, 'data.data_provider.entity_id', '')
    if (entityId) savedIds.push(entityId)
  })

  return savedIds
}

type BrowseComparablesParams = {
  browseComparableType: string,
  dataProviderPropertyId: number,
  entityOptions: object,
}

export const browseComparables = async (params: BrowseComparablesParams) => {
  const { browseComparableType, dataProviderPropertyId, entityOptions } = params

  const endpoint = getComparableUrl({ comparableType: browseComparableType, dataProviderPropertyId })

  const result = await callApi<CampaignComparableModel[]>(endpoint, entityOptions)

  return result
}

export default browseComparables
